import styled from 'styled-components';

export const TimeActiveItemWrapper = styled.div`
  .attendance-count-down {
    color: rgb(246, 81, 113);
    font-size: 1.5rem;
    margin-left: 2rem;
  }
`;
export const TimeWrapper = styled.div`
  display: flex;
  color: #f65171;
  margin-left: 0.75rem;
`;
export const Brackets = styled.div`
  font-size: 4.5rem;
  line-height: 4rem;
  font-weight: 200;
  user-select: none;
`;
export const TimeContent = styled.div`
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 0.3rem;
  margin-right: 0.3rem;
  margin-left: 0.3rem;
`;
